import {useEffect} from 'react'
import {Organisation, Environment, BillingInfo, BillingActivity, ApiConsumer} from '@eitje/api'
import {notifications} from '~/components'

export const useFetchRecords = () => {
	useFetchData(Environment)
	useFetchData(BillingInfo)
	useFetchData(Organisation)
	useFetchData(BillingActivity)
	useFetchData(ApiConsumer)
}

const useFetchData = (model, filters) => {
	useEffect(() => {
		const fetchData = async () => {
			const res = await model.index(filters)
			if (res.status === 504) {
				notifications.errorNotif({
					title: "Can't fetch data",
					content: `Failed to fetch ${model.tableName} data.`,
				})
			}
		}

		fetchData()
	}, [])
}
